
import { Factcheck } from "@/types";
import { Component, Vue } from "vue-property-decorator";

import * as FactCheckService from '@/services/FactCheckService';
import { askConfirm } from '@/content/confirm';

@Component
export default class Index extends Vue {
  concepts: any[] = []

  async mounted(){
    this.concepts = await FactCheckService.GetConcepts();
  }

  async deleteConcept(conceptId: string){
    if (!await askConfirm({ title: 'Concept verwijderen?', text: 'Het concept wordt meteen verwijderd en kan niet teruggezet worden.', confirmLabel: 'Verwijderen', danger: true })) return;
    await FactCheckService.DeleteConcept(conceptId);
    this.concepts = await FactCheckService.GetConcepts();
  }
}
